export const TITLE_CELL_WIDTH = 300;
export const ACTION_CELL_WIDTH = 60;
